import { routerMiddleware } from 'connected-react-router'
import { applyMiddleware, compose, createStore, StoreEnhancer } from 'redux'
import thunkMiddleware, { ThunkMiddleware } from 'redux-thunk'

import { gaMiddleware } from '@src/state/gtm'
import rootLogic from '@src/state/logics'
import { opMiddleware } from '@src/state/optimizely/middleware'
import createReducer, { createRootReducer } from '@src/state/reducers'
import { setReduxHooks } from '@src/utils/http-clients'
import { allowDebug } from '@src/utils/localStorage'
import { createBrowserHistory, History } from 'history'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createLogicMiddleware } from 'redux-logic'
import { wtaMiddleware } from './state/analytics'

export const history = createBrowserHistory()

export const createMiddlewares = (suppliedHistory?: History<any>) => [
  routerMiddleware(suppliedHistory ?? history),
  gaMiddleware,
  wtaMiddleware,
  thunkMiddleware as ThunkMiddleware,
  opMiddleware,
]

const chooseComposeFunc = (enhancers: StoreEnhancer[]): StoreEnhancer =>
  !process.env.REACT_APP_PRODUCTION || allowDebug()
    ? composeWithDevTools(...enhancers)
    : compose(...enhancers)

export default function configureStore(preloadedState?: any) {
  const reducerWithRouter = createReducer(createRootReducer(history))

  const logicMiddleware = createLogicMiddleware(rootLogic)

  const middlewareEnhancer = applyMiddleware(logicMiddleware, ...createMiddlewares())
  const enhancers = [middlewareEnhancer]
  const composedEnhancers = chooseComposeFunc(enhancers)
  const store = createStore(reducerWithRouter, preloadedState, composedEnhancers)

  setReduxHooks(store)

  return store
}



// WEBPACK FOOTER //
// ./src/configureStore.ts